(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/javascripts/pay/make-payment.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/javascripts/pay/make-payment.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  packageConfig
} = svs.gamePackage.data;
const {
  getProductName
} = svs.numbergames.productMapping;
const {
  joinWithPunctuation
} = svs.tur.pay.utils.format_text;
const {
  accountSelector
} = svs.numbergames;
const {
  checkAndShowSyndicateTermsDialogAsync
} = svs.syndicate.rules_and_terms;
const {
  CurrencyFromJupiterString: currencyFromJupiterString
} = svs.utils.format;
const {
  errors: {
    INVALID_ACCOUNT_SELECTED
  }
} = svs.numbergames.accountSelector.constants;
const {
  account_services: accountServices,
  api_calls: apiCalls,
  communication,
  dialogs,
  misc
} = svs.tur.pay;
const {
  toApiWagers,
  handlePayResponse,
  trackPayment,
  drawClosedDialog
} = svs.gamePackage.pay;
const currency = svs.utils.format.Currency;
function setPackageSizeParam(_ref) {
  let {
    next,
    sizeParam
  } = _ref;
  svs.utils.paramHandler.set({
    key: 'bag',
    value: sizeParam
  });
  next();
}
function calculateActualPaidPrice(_ref2) {
  let {
    next,
    successfulWagers,
    successfulTickets
  } = _ref2;
  const wagersPrice = (sum, _ref3) => {
    let {
      wagerAmounts
    } = _ref3;
    return sum + svs.utils.format.CurrencyFromJupiterString(wagerAmounts.betAmount);
  };
  const ticketsPrice = (sum, _ref4) => {
    let {
      price
    } = _ref4;
    return sum + price;
  };
  next({
    actualPaidPrice: successfulWagers.reduce(wagersPrice, 0) + successfulTickets.reduce(ticketsPrice, 0)
  });
}
function removeGamesFromLocalStorage(_ref5) {
  let {
    next,
    activeIndex
  } = _ref5;
  const {
    dispatch
  } = svs.gamePackage.redux.store;
  const {
    updateIndex
  } = svs.gamePackage.redux.gamePackageSlice.actions;
  svs.gamePackage.redux.middlewares.removeGamesFromLocalStorage({
    index: activeIndex,
    onRemoved: () => {
      dispatch(updateIndex({
        activeIndex
      }));
    }
  });
  next();
}
async function activeAccount(_ref6) {
  let {
    next
  } = _ref6;
  svs.ui.loader.show();
  let account;
  try {
    account = await accountSelector.getActiveAccount();
  } catch (error) {
    if (error.type === INVALID_ACCOUNT_SELECTED) {
      svs.gamePackage.logger.warn('AccountSelector reported that the user tried to play with an inactive or non existing syndicate, falling back to players account', error);
    } else {
      svs.gamePackage.logger.warn('Error when getting selected account from AccountSeletor component, falling back to players account', error);
    }
    try {
      account = await accountSelector.usePlayerAccount();
    } catch (err) {
      svs.gamePackage.logger.warn('AccountSelector was unable to revert to using the players account, using static fallback', err);
      account = {
        isSyndicate: false
      };
    }
  }
  svs.ui.loader.hide();
  const syndicate = {
    syndicateId: account.id,
    syndicateName: account.name,
    playableAmount: account.balance
  };
  const isSyndicate = account.isSyndicate;
  next({
    syndicate,
    isSyndicate
  });
}
async function checkSyndicateTerms(_ref7) {
  let {
    next,
    isSyndicate
  } = _ref7;
  if (isSyndicate) {
    await checkAndShowSyndicateTermsDialogAsync();
  }
  next();
}
function calculateNewBalance(_ref8) {
  let {
    next,
    accountBalance,
    actualPaidPrice,
    syndicate,
    isSyndicate
  } = _ref8;
  let currentBalance;
  if (isSyndicate) {
    currentBalance = syndicate.playableAmount;
  } else {
    currentBalance = currencyFromJupiterString(accountBalance);
  }
  next({
    newBalance: currentBalance - actualPaidPrice
  });
}
async function updateAccountBalance(_ref9) {
  let {
    next,
    newBalance,
    syndicate,
    isSyndicate
  } = _ref9;
  if (isSyndicate) {
    svs.ui.loader.show();
    try {
      await accountSelector.updateAccountBalance({
        accountId: syndicate.syndicateId,
        balance: newBalance
      });
    } catch (error) {
      svs.gamePackage.logger.warn("AccountSelector was not able to update balance after purchase for accountId: ".concat(syndicate.id, ", new balance was: ").concat(newBalance, "."), error);
    }
    svs.ui.loader.hide();
  } else {
    svs.components.account_balance.set(newBalance);
  }
  next();
}
function makePayment() {
  let {
    onSuccess
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const product = packageConfig.title;
  const {
    gamePackage,
    tickets,
    numbergames
  } = svs.gamePackage.redux.store.getState();
  const {
    sizes,
    activeIndex
  } = gamePackage;
  const sizeParam = packageConfig.packageSizes[activeIndex].packageKey;
  const {
    label,
    price,
    gamePackageId
  } = sizes[activeIndex];
  const uniqueProducts = [...new Set(numbergames.games.map(game => getProductName(game.productId)))];
  let syndicate;
  let isSyndicate;
  let draws;
  let wagers;
  let accountBalance;
  let regWagerResults;
  let successfulWagers;
  let incompleteWagers;
  let failedWagers;
  let drawIsClosed;
  let closedProductItsId;
  let successfulTickets;
  let failedTickets;
  let actualPaidPrice;
  let grassrootsReceivers;
  let newBalance;
  const calls = [{
    in: () => ({
      sizeParam
    }),
    fn: setPackageSizeParam
  }, {
    in: () => ({
      price,
      product,
      drawCount: 1
    }),
    fn: accountServices.playerSession
  }, {
    fn: activeAccount,
    out: args => ({
      syndicate,
      isSyndicate
    } = args)
  }, {
    in: () => ({
      isSyndicate
    }),
    fn: checkSyndicateTerms
  }, {
    in: () => ({
      gamePackageId,
      isSyndicate,
      syndicate
    }),
    fn: toApiWagers,
    out: args => ({
      draws,
      wagers
    } = args)
  }, {
    fn: accountServices.playerSuspension
  }, {
    fn: accountServices.dayTimeLimit
  }, {
    in: () => ({
      price,
      isSyndicate,
      syndicate
    }),
    fn: accountServices.accountBalance,
    out: args => ({
      accountBalance
    } = args)
  }, {
    in: () => ({
      accountBalance,
      isSyndicate,
      syndicate,
      price,
      product
    }),
    fn: args => {
      const confirmPaymentMessage = tickets.games.length ? "".concat(joinWithPunctuation(uniqueProducts), " g\xE5r att annullera.") : 'Spelen går att annullera.';
      const confirmPaymentOptions = {
        title: "Vill du betala ett ".concat(isSyndicate ? 'lag' : '', "spel p\xE5 ").concat(product, "\xA0").concat(label, " f\xF6r\xA0").concat(currency(price), "\xA0kr?"),
        messages: [confirmPaymentMessage]
      };
      dialogs.confirmPayment(_objectSpread(_objectSpread({}, args), confirmPaymentOptions));
    }
  }, {
    in: () => ({
      wagers
    }),
    fn: apiCalls.payMultipleWagers,
    out: args => ({
      regWagerResults
    } = args)
  }, {
    in: () => ({
      regWagerResults,
      wagers,
      successfulWagers,
      failedWagers
    }),
    fn: handlePayResponse,
    out: args => ({
      drawIsClosed,
      closedProductItsId,
      incompleteWagers,
      successfulWagers,
      failedWagers
    } = args)
  }, function handleDrawClosed() {
    if (drawIsClosed) {
      return {
        calls: [{
          in: () => ({
            gamePackageId,
            isSyndicate,
            syndicate
          }),
          fn: toApiWagers,
          out: args => ({
            draws,
            wagers
          } = args)
        }, {
          in: () => ({
            closedProductItsId,
            draws
          }),
          fn: drawClosedDialog
        }, {
          in: () => ({
            wagers
          }),
          fn: apiCalls.payMultipleWagers,
          out: args => ({
            regWagerResults
          } = args)
        }, {
          in: () => ({
            regWagerResults,
            wagers,
            successfulWagers,
            failedWagers
          }),
          fn: handlePayResponse,
          out: args => ({
            drawIsClosed,
            closedProductItsId,
            incompleteWagers,
            successfulWagers,
            failedWagers
          } = args)
        }, handleDrawClosed]
      };
    }
  }, function handleIncompleteWagers() {
    if (Array.isArray(incompleteWagers) && incompleteWagers.length) {
      return {
        calls: [{
          in: () => ({
            wagers: incompleteWagers
          }),
          fn: apiCalls.payMultipleWagers,
          out: args => ({
            regWagerResults
          } = args)
        }, {
          in: () => ({
            regWagerResults,
            wagers,
            successfulWagers,
            failedWagers
          }),
          fn: handlePayResponse,
          out: args => ({
            incompleteWagers,
            successfulWagers,
            failedWagers
          } = args)
        }, handleIncompleteWagers]
      };
    }
  }, {
    in: () => ({
      ticket: tickets.games[0],
      channel: sizeParam
    }),
    fn: apiCalls.payTicket,
    out: args => ({
      successfulTickets,
      failedTickets
    } = args)
  }, {
    in: () => ({
      successfulWagers,
      successfulTickets
    }),
    fn: calculateActualPaidPrice,
    out: args => ({
      actualPaidPrice
    } = args)
  }, {
    in: () => ({
      product,
      price,
      actualPaidPrice,
      successfulWagers
    }),
    fn: trackPayment
  }, {
    in: () => ({
      activeIndex
    }),
    fn: removeGamesFromLocalStorage
  }, {
    in: () => ({
      isSyndicate
    }),
    fn: misc.getGrassrootsReceivers,
    out: args => ({
      grassrootsReceivers
    } = args)
  }, {
    in: () => ({
      title: dialogs.getSuccessTitle({
        product,
        isSyndicate,
        failedWagers,
        failedTickets
      }),
      messages: dialogs.getSuccessMessages({
        product,
        successfulTickets,
        isSyndicate,
        failedWagers,
        price: actualPaidPrice,
        grassrootsReceivers,
        failedTickets
      }),
      isSyndicate,
      product,
      successfulTickets
    }),
    fn: dialogs.paymentSuccess
  }, {
    in: () => ({
      accountBalance,
      actualPaidPrice,
      syndicate,
      isSyndicate
    }),
    fn: calculateNewBalance,
    out: args => ({
      newBalance
    } = args)
  }, {
    in: () => ({
      newBalance,
      syndicate,
      isSyndicate
    }),
    fn: updateAccountBalance
  }, {
    in: () => ({
      product,
      packagedProducts: uniqueProducts
    }),
    fn: communication.correctionEmail
  }, {
    fn: misc.showGrassrootsToaster
  }];
  const cleanup = () => {
    svs.utils.paramHandler.remove({
      key: 'bag'
    });
  };
  svs.tur.pay.initPay({
    calls,
    done: () => {
      onSuccess && onSuccess({
        newBalance
      });
      cleanup();
    },
    cancel: cleanup
  });
}
svs.gamePackage.pay.makePayment = makePayment;

 })(window);